"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _downshift = require("downshift");
var _underscore = _interopRequireDefault(require("underscore"));
var _filter_items = _interopRequireDefault(require("./utils/filter_items"));
var _reactUse = require("react-use");
var _flatten_items = _interopRequireDefault(require("./utils/flatten_items"));
var _useDebouncing2 = _interopRequireDefault(require("./useDebouncing"));
var _useVirtualization = _interopRequireDefault(require("./useVirtualization"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var stateReducer = function stateReducer(state, actionAndChanges) {
  var _changes$selectedItem, _state$selectedItem;
  var changes = actionAndChanges.changes,
    type = actionAndChanges.type;
  if (changes !== null && changes !== void 0 && (_changes$selectedItem = changes.selectedItem) !== null && _changes$selectedItem !== void 0 && _changes$selectedItem.disabled) {
    return state;
  }
  switch (type) {
    case _downshift.useCombobox.stateChangeTypes.InputKeyDownEscape:
    case _downshift.useCombobox.stateChangeTypes.InputBlur:
      return _objectSpread(_objectSpread({}, state), {}, {
        inputValue: ((_state$selectedItem = state.selectedItem) === null || _state$selectedItem === void 0 ? void 0 : _state$selectedItem.label) || '',
        isOpen: changes.isOpen
      });
  }
  return changes;
};
var useSingleDropdown = function useSingleDropdown(options) {
  var itemToString = function itemToString(item) {
    return (item === null || item === void 0 ? void 0 : item.label) || '';
  };
  var _React$useState = React.useState((0, _flatten_items["default"])(options.items || [])),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    items = _React$useState2[0],
    setItems = _React$useState2[1];
  var fetchItems = options.fetchItems,
    paginated = options.paginated;
  var triggerFetch = React.useMemo(function () {
    if (fetchItems && !paginated) {
      return /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(filter) {
          var result;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetchItems(filter);
              case 3:
                result = _context.sent;
                setItems((0, _flatten_items["default"])(result.items));
                setLoadingStatus('loaded');
                _context.next = 12;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                setLoadingStatus('error');
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 8]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }
  }, [fetchItems, paginated]);
  var more = React.useRef(false);
  var triggerPaginatedFetch = React.useMemo(function () {
    if (fetchItems && paginated) {
      return /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(filter, nextPage) {
          var result, newItems;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return fetchItems(filter, nextPage);
              case 3:
                result = _context2.sent;
                more.current = result.more;
                currentPage.current = nextPage;
                newItems = [];
                if (nextPage === 1) {
                  newItems = (0, _flatten_items["default"])(result.items);
                } else {
                  newItems = items.concat((0, _flatten_items["default"])(result.items));
                }
                setItems(newItems);
                setLoadingStatus('loaded');
                _context2.next = 16;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);
                setLoadingStatus('error');
              case 16:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 12]]);
        }));
        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
    }
  }, [fetchItems, paginated, items]);
  (0, _reactUse.useEffectOnce)(function () {
    if (!options.preventLoadOnMount && fetchItems) {
      if (paginated && triggerPaginatedFetch) {
        triggerPaginatedFetch('', currentPage.current);
      } else if (triggerFetch) {
        triggerFetch('');
      }
    }
  });
  var _useDebouncing = (0, _useDebouncing2["default"])({
      triggerFetch: triggerFetch,
      triggerPaginatedFetch: triggerPaginatedFetch,
      debounceWait: options.debounceWait
    }),
    triggerDebouncedFetch = _useDebouncing.triggerDebouncedFetch,
    triggerDebouncedPaginatedFetch = _useDebouncing.triggerDebouncedPaginatedFetch;
  var _React$useState3 = React.useState(fetchItems ? 'initial' : 'loaded'),
    _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
    loadingStatus = _React$useState4[0],
    setLoadingStatus = _React$useState4[1];
  var currentSearchTerm = React.useRef('');
  var currentPage = React.useRef(0);
  var _onInputValueChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(inputValue) {
      var newItems;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            currentSearchTerm.current = inputValue;
            if (triggerDebouncedPaginatedFetch) {
              setLoadingStatus('loading');
              triggerDebouncedPaginatedFetch(inputValue, 1);
            } else if (triggerDebouncedFetch) {
              setLoadingStatus('loading');
              triggerDebouncedFetch(inputValue);
            } else if (options.items) {
              newItems = (0, _filter_items["default"])(options.items, inputValue);
              setItems((0, _flatten_items["default"])(newItems));
            }
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onInputValueChange(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var defaultOptions = {
    itemToString: itemToString,
    onInputValueChange: function () {
      var _onInputValueChange2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(e) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _onInputValueChange(e.inputValue);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function onInputValueChange(_x5) {
        return _onInputValueChange2.apply(this, arguments);
      }
      return onInputValueChange;
    }(),
    stateReducer: stateReducer,
    defaultHighlightedIndex: 0
  };
  var overrides = {
    items: items
  };
  var comboboxOptions = Object.assign({
    onHighlightedIndexChange: function onHighlightedIndexChange(_ref4) {
      var highlightedIndex = _ref4.highlightedIndex,
        type = _ref4.type;
      if (type !== _downshift.useCombobox.stateChangeTypes.MenuMouseLeave) {
        virtualizationProps.rowVirtualizer.scrollToIndex(highlightedIndex);
      }
    },
    onStateChange: function onStateChange(_ref5) {
      var type = _ref5.type,
        selectedItem = _ref5.selectedItem;
      switch (type) {
        case _downshift.useCombobox.stateChangeTypes.InputKeyDownEnter:
        case _downshift.useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            _onInputValueChange('');
          } else {
            if (_underscore["default"].isEmpty(items)) {
              _onInputValueChange('');
            }
          }
          break;
        case _downshift.useCombobox.stateChangeTypes.FunctionOpenMenu:
          _onInputValueChange('');
          break;
        default:
          break;
      }
    }
  }, defaultOptions, options, overrides);
  var useVirtualizationProps = {
    items: items,
    loadingStatus: loadingStatus,
    setLoadingStatus: setLoadingStatus,
    currentSearchTerm: currentSearchTerm.current
  };
  if (paginated && triggerPaginatedFetch) {
    useVirtualizationProps = _objectSpread(_objectSpread({}, useVirtualizationProps), {}, {
      triggerPaginatedFetch: triggerPaginatedFetch,
      currentPage: currentPage.current,
      shouldFetchNextPage: more.current
    });
  }
  var virtualizationProps = (0, _useVirtualization["default"])(useVirtualizationProps);
  return _objectSpread(_objectSpread(_objectSpread({}, (0, _downshift.useCombobox)(comboboxOptions)), {}, {
    items: items,
    loadingStatus: loadingStatus,
    loadInitialOptions: function loadInitialOptions(searchTerm) {
      // for some reason this breaks filter clearing on item select
      _onInputValueChange(searchTerm || '');
    }
  }, virtualizationProps), {}, {
    isPaginated: triggerPaginatedFetch ? true : false,
    total: items.length
  });
};
var _default = exports["default"] = useSingleDropdown;